module.exports = __webpack_public_path__ + "static/img/shangshiqy.446d4dcb.png";